import React, { FC } from 'react';

import gearImage from '../../../../assets/images/svg/gear.svg';
import { cn } from '../../../../utils';
import { Image } from '../../images';
import { ButtonProps } from '../Button/Button';
import { Button } from '../index';

import './GearButton.scoped.scss';

const GearButton: FC<ButtonProps> = ({ ...props }) => {
  return (
    <Button {...props} className={cn('gear-button', props.className)}>
      <Image src={gearImage} />
    </Button>
  );
};

export default GearButton;
